import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import * as React from "react";
import * as ReactDOM from "react-dom";
import * as OfficeHelpers from "@microsoft/office-js-helpers";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-dropdown/style.css";
import "./assets/style/index.css";
import "react-overlay-loader/styles.css";
import "./axios-interceptor";
import OutOfOffice from "./OutOfOffice";
import "./styles/global.scss";

const renderApp = () => {
    ReactDOM.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
        document.getElementById("root")
    );
};

const renderWarning = () => {
    ReactDOM.render(<OutOfOffice />, document.getElementById("root"));
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

Office.onReady(() => {
    if (OfficeHelpers.Utilities.platform) {
        renderApp();
    } else {
        renderWarning();
    }
});
